import React from "react";
import { useState, useEffect } from "react";
import { TopMenuBar } from "../components/TopMenuBar/TopMenuBar";
import Button from "@mui/material/Button";
import "./style.css";
import "@fontsource-variable/open-sans";

export const MenuLandingPage = () => {
  const [isDisabled, setIsDisabled] = useState(false);

  useEffect(() => {
    const lastLoadOut = localStorage.getItem("lastLoadOut");
    // localStorage returns strings, so check for '0' or a literal 0
    if (lastLoadOut === "0" || lastLoadOut === 0) {
      setIsDisabled(true);
    }
  }, []);

  return (
    <div className="menu-landing">
      <div className="overlap-group">
        <TopMenuBar />
        <div className="start">
          <p className="trust-security-and">
            <span className="span">Trust, Security and Traceability{"  "}</span>
            <span className="text-wrapper-2">for supply chains.</span>
          </p>
          <div className="div">
            <button className="button-wrapper">
              <Button href="#/newPack" className="button-2">
                New Packout
              </Button>
            </button>
            <button
              className={`div-wrapper ${isDisabled ? "is-disabled" : ""}`}
              disabled={isDisabled}
            >
              <Button
                href={isDisabled ? undefined : "#/packingListPage"}
                className="button-3"
                disabled={isDisabled}
              >
                Previous Packout
              </Button>
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default MenuLandingPage;
